function getParameter(param, where, separator, splitter) {
  var query = where ? where : window.location.search.substring(1);
  var vars = query.split(separator ? separator : "&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split(splitter ? splitter : "=");
    if(pair[0] == param) {
      return pair[1];
    }
  }
  return false;
};

function getLocale() {
  if (window.DEBUG && getParameter("lang")) {
    return getParameter("lang");
  } else {
    return navigator.language.split("-")[0];
  }
}

function throttle(fn, wait) {
  var time = Date.now();
  return function() {
    if ((time + wait - Date.now()) < 0) {
      fn();
      time = Date.now();
    }
  }
}

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    }, wait);
    if (immediate && !timeout) func.apply(context, args);
  };
}

export {getParameter, getLocale, throttle, debounce};


//////////////////
// WEBPACK FOOTER
// ./src/js/utils.js
// module id = 3
// module chunks = 0